














































































import Vue from "vue";
import Modal from "@/components/Modal/Modal.vue";
import { store } from "@/store/store";
import Paragraph from "@/components/Text/Global/Paragraph.vue";
import { ApiResponse } from "@/types/types";
import { Category } from "@/store/modules/Category/interface";
import { State } from "@/store/modules/State/interface";
import { UpdateInfo } from "@/store/modules/Device/interface";
import { DeviceActionsTypes } from "@/store/modules/Device/types";
import { Response_ } from "@/plugins/axios/response";
import Utils from "@/utils/utils";
import { Agence } from "@/store/modules/Agence/interface";

export default Vue.extend({
  name: "DeviceMultipleUpdateModal",
  components: { Modal, Paragraph },
  props: {
    should_display: {
      type: Boolean,
      default: false
    },
    onClose: {
      type: Function,
      default: () => undefined
    },
    onValidate: {
      type: Function,
      default: () => undefined
    },
    devices: {
      type: Array as () => Array<string>
    },
    onAction: {
      type: Function,
      default: () => undefined
    }
  },
  data(): any {
    return {
      form: { category: "", state: "" },
      loading: false
    };
  },
  methods: {
    onInputChange(value: string, type: string): void {
      if (value !== "") Utils.transformStringBoolean(value);
      this.form[type] = value;
    },
    async validate(): Promise<void> {
      const inputs: any = {};
      for (const key in this.form) {
        if (this.form[key] !== "" && this.form[key] !== null) {
          inputs[key] = this.form[key];
        }
      }
      if (Object.keys(inputs).length !== 0) {
        const request_result = await this.update(inputs);
        if (
          (request_result as Response_).status === ApiResponse.CREATED ||
          (request_result as Response_).status === ApiResponse.SUCCESS
        ) {
          this.onAction({
            type: "SUCCESS",
            title: "Modification",
            content: (request_result as Response_).message
          });
          this.loading = false;
          this.onClose();
          return;
        } else {
          this.onAction({
            type: "ERROR",
            title: "Erreur",
            content: (request_result as Response_).message
          });
        }
      }
      this.loading = false;
    },
    async update(update_info: UpdateInfo): Promise<Response_> {
      const update_object: any = {
        ids: this.devices,
        update: update_info
      };
      return await store.dispatch(DeviceActionsTypes.UPDATE_MULTIPLE_DEVICE, update_object);
    }
  },
  computed: {
    devicesName(): Array<string> {
      return this.devices.map((device_id: string) => store.getters.DEVICE_BY_ID[device_id].material_name);
    },
    categories(): Array<Category> {
      return store.getters.CATEGORY_ALL_ID.map((category) => store.getters.CATEGORY_BY_ID[category]);
    },
    agences(): Array<Agence> {
      return store.getters.AGENCE_ALL_ID.map((agence) => store.getters.AGENCE_BY_ID[agence]);
    },
    states(): Array<State> {
      return store.getters.STATE_ALL_ID.map((state) => store.getters.STATE_BY_ID[state]);
    }
  },
  watch: {}
});
